import { Cell, CellWithHierarchy } from '@pelckmans/elementis/components/table';
import { StudentAssignment } from '../api/AssignmentStudentApi';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Assignment from './Assignment';

const BASE = 'PAGES.ASSIGNMENTS.STUDENT.SECTION.TABLE.BODY.ASSIGNMENT_DIVISIONS';

export type EndDateCategory = 'TODAY' | 'THIS_WEEK' | 'LATER';

type AssignmentDivisionProps = {
  endDateCategory: EndDateCategory;
  assigments: StudentAssignment[];
};

function AssignmentDivision({ endDateCategory, assigments }: AssignmentDivisionProps) {
  const [collapsed, setCollapsed] = useState(false);
  const { t } = useTranslation();

  const isEmpty = assigments.length === 0;
  const hasOne = assigments.length === 1;

  return (
    <>
      <tr>
        <CellWithHierarchy
          highlighted
          hierarchyProps={{
            level: 0,
            onToggleCollapsed: () => setCollapsed(x => !x),
            collapsed,
            collapseButtonLabelText: t(`${BASE}.COLLAPSE_BUTTON.A11Y_LABEL`),
          }}
          colspan={5}
        >
          <Cell.Text
            title={t(`${BASE}.END_DATE.${endDateCategory}`)}
            subTitleBot={
              hasOne ? t(`${BASE}.ONE_ASSIGNMENT`) : t(`${BASE}.ASSIGNMENTS_COUNT`, { count: assigments.length })
            }
          />
        </CellWithHierarchy>
      </tr>
      {!collapsed && isEmpty && (
        <tr>
          <CellWithHierarchy hierarchyProps={{ level: 1 }} colspan={5}>
            <Cell.Message title={t(`${BASE}.EMPTY_MESSAGE.${endDateCategory}`)} />
          </CellWithHierarchy>
        </tr>
      )}
      {!collapsed &&
        !isEmpty &&
        assigments.map(assignment => (
          <Assignment key={assignment.id} assignment={assignment} endDateCategory={endDateCategory} />
        ))}
    </>
  );
}

export default AssignmentDivision;
